<template>
  <div class="question-bank">
    <div class="header">
      <h1>题库搜索</h1>
    </div>

    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-form">
        <div class="form-group">
          <label>关键词：</label>
          <input 
            type="text" 
            v-model="searchQuery" 
            placeholder="请输入搜索关键词"
            class="search-input"
            @keyup.enter="searchQuestions"
          >
        </div>
        <button @click="searchQuestions" class="search-btn" :disabled="isLoading">
          {{ isLoading ? '搜索中...' : '搜索' }}
        </button>
      </div>
    </div>

    <!-- 搜索结果展示 -->
    <div class="search-results" v-if="searchPerformed">
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      <div v-else-if="result" class="result-card">
        <h3>搜索结果</h3>
        <div class="result-content">
          {{ result }}
        </div>
      </div>
      <div v-else class="no-result">
        暂无搜索结果
      </div>
    </div>
  </div>
</template>

<script>
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';

export default {
  name: 'QuestionBankPage',
  data() {
    return {
      searchQuery: '',
      result: null,
      error: null,
      isLoading: false,
      searchPerformed: false
    }
  },
  methods: {
    async searchQuestions() {
      if (!this.searchQuery.trim()) {
        this.error = '请输入搜索关键词';
        return;
      }

      this.isLoading = true;
      this.error = null;
      this.result = null;
      this.searchPerformed = true;

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.$router.push('/login');
          return;
        }

        // 从localStorage获取用户信息以获取tktoken
        const userStr = localStorage.getItem('user');
        if (!userStr) {
          this.error = '请先获取TK Token';
          return;
        }

        const user = JSON.parse(userStr);
        if (!user.tktoken) {
          this.error = '请先在个人中心获取TK Token';
          return;
        }

        // 构建URL
        const url = `${API_BASE_URL}${API_ENDPOINTS.QUESTION.QUERY}?q=${encodeURIComponent(this.searchQuery)}&tktoken=${user.tktoken}`;

        const response = await fetch(url, {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });

        if (!response.ok) {
          throw new Error('搜索请求失败');
        }

        const data = await response.json();
        const payload = data && typeof data.data === 'object' ? data.data : data;

        if (payload?.code === 1) {
          this.result = payload.data || payload.msg;
        } else {
          this.error = payload?.msg || '搜索失败';
        }
      } catch (error) {
        console.error('搜索失败:', error);
        this.error = '搜索失败，请稍后重试';
      } finally {
        this.isLoading = false;
      }
    }
  }
}
</script>

<style scoped>
.question-bank {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
}

.header {
  text-align: center;
  margin-bottom: 40px;
}

h1 {
  color: #2c3e50;
  margin: 0;
  font-size: 32px;
  font-weight: 600;
}

.search-section {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.search-form {
  display: flex;
  gap: 15px;
  align-items: flex-end;
}

.form-group {
  flex: 1;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #2c3e50;
  font-weight: 500;
}

.search-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #4CAF50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.1);
}

.search-btn {
  padding: 12px 24px;
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.search-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
}

.search-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.search-results {
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.error-message {
  color: #f44336;
  padding: 16px;
  background-color: #ffebee;
  border-radius: 8px;
  border-left: 4px solid #f44336;
}

.retry-btn {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 10px;
  font-size: 12px;
}

.result-card {
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #4CAF50;
}

.result-card h3 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #2c3e50;
}

.result-content {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.6;
  color: #495057;
}

.no-result {
  text-align: center;
  color: #6c757d;
  padding: 40px;
}



/* 响应式设计 */
@media (max-width: 768px) {
  .question-bank {
    padding: 10px;
  }
  
  .header h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .search-section {
    padding: 20px 15px;
    margin-bottom: 15px;
  }
  
  .search-form {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
  
  .search-input {
    padding: 14px;
    font-size: 16px; /* 防止iOS缩放 */
  }
  
  .search-btn {
    padding: 14px 24px;
    font-size: 16px;
    width: 100%;
  }
  
  .search-results {
    padding: 20px 15px;
    margin: 0 -10px;
    border-radius: 12px;
  }
  
  .result-card {
    padding: 15px;
  }
  
  .result-card h3 {
    font-size: 18px;
  }
  
  .result-content {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .question-bank {
    padding: 5px;
  }
  
  .header h1 {
    font-size: 22px;
    text-align: center;
  }
  
  .search-section {
    padding: 15px 10px;
  }
  
  .search-input {
    padding: 12px;
  }
  
  .search-btn {
    padding: 12px 20px;
  }
  
  .search-results {
    padding: 15px 10px;
  }
  
  .result-card {
    padding: 12px;
  }
  
  .error-message {
    padding: 12px;
    font-size: 14px;
  }
}

/* 触摸设备优化 */
@media (hover: none) and (pointer: coarse) {
  .search-btn:hover:not(:disabled) {
    transform: none;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
  }
  
  .search-btn:active:not(:disabled) {
    transform: scale(0.98);
  }
  
  .search-input {
    -webkit-appearance: none;
    border-radius: 8px;
  }
}
</style>
